
import '../css/Home.css'
import profileImg from '../images/profile.jpg'


const Home = () => {


    return (
        <section className="home">
            <div className='profileImage'>
                <img src={profileImg} alt='IMG' ></img>

            </div>
            <div className='description'>
                <h1> Hi I'm Saif </h1><br />
                <h3>Fullstack Developer</h3>
                <p>I’m Saif, a MERN Stack Developer with expertise in building full-stack applications using MongoDB, Express.js, React, and Node.js. I’m passionate about creating scalable, responsive, and user-friendly web applications, ensuring a seamless experience from front-end to back-end. </p>
            </div>

        </section>
    )
}

export default Home